module.exports = __webpack_public_path__ + "img/qr-code-ios.b3da4156.png";